/* define to prevent inheritance */
@property --rounded-panel-bg {
  syntax: "<color>";
  inherits: false;
  initial-value: #F8F8F8;
}

.rounded-panel {
  --rounded-panel-spacing: var(--spacing-small);
  --_rounded-panel-bg: var(--rounded-panel-bg);

  background-color: var(--_rounded-panel-bg);
  padding: var(--rounded-panel-spacing);
  border-radius: 10px;
}

.box-shadow {
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.15);
}